import type { IErrorResponse, UserRateNew } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { urls } from '@/statics';
import { api } from '@/utils';

const useGetRateNew = (): UseMutationResult<
  UserRateNew,
  IErrorResponse,
  { news_id: string }
> => useMutation({ mutationFn: (data) => api.post(urls.getRateNew, data) });

export default useGetRateNew;
